const Score = ({ data }) => {
  const colorChooser = (data, opacity) => {
    if (data < 0) {
      return `rgba(84, 158, 231, ${opacity})`;
    } else if (data < 1) {
      return `rgba(255, 95, 125, ${opacity})`;
    } else if (data < 80) {
      return `rgba(255, 203, 96, ${opacity})`;
    } else {
      return `rgba(62, 210, 153, ${opacity})`;
    }
  };

  const positionChooser = (data) => {
    if (data === 0) {
      return '5%';
    } else if (data === 1) {
      return '10%';
    } else if (data < 80) {
      return `${data + 10}%`;
    } else {
      return `${data}%`;
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          position: 'absolute',
          left: positionChooser(data),
          transform: 'translateX(-50%)',
        }}
      >
        <div
          style={{
            position: 'absolute',
            bottom: '100%',
            left: '50%',
            transform: 'translate(-50%, -25%) rotate(45deg)',
            background: colorChooser(data, 0.2),
            height: '2rem',
            width: '2rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50% 50% 0 50%',
          }}
        >
          <span
            style={{
              transform: 'rotate(-45deg)',
              fontSize: '0.875rem',
              fontWeight: '500',
              color: colorChooser(data, 1),
            }}
          >
            {data}
          </span>
        </div>
      </div>

      <div
        style={{
          height: '0.375rem',
          width: '100%',
          borderRadius: '0.5rem',
          background:
            'linear-gradient(to right, rgb(84, 158, 231) 0%, rgb(84, 158, 231) calc(5% - 0.0625rem), white calc(5% - 0.0625rem) calc(5% + 0.0625rem), rgb(255, 95, 125) calc(5% + 0.0625rem) calc(10% - 0.0625rem), white calc(10% - 0.0625rem) calc(10% + 0.0625rem), rgb(255, 203, 96) calc(10% + 0.0625rem) calc(80% - 0.0625rem), white calc(80% - 0.0625rem) calc(80% + 0.0625rem), rgb(62, 210, 153) calc(80% + 0.0625rem) 100%)',
        }}
      ></div>
      <ul
        style={{
          marginTop: '0.25rem',
          color: '#6b7280', // Gray text
          position: 'relative',
          display: 'flex',
          justifyContent: 'space-between',
          listStyleType: 'none',
          padding: '0',
          fontSize: '0.875rem',
        }}
      >
        <li style={{ position: 'absolute', left: '0%' }}>?</li>
        <li style={{ position: 'absolute', left: '5%', transform: 'translateX(-50%)' }}>0</li>
        <li style={{ position: 'absolute', left: '10%', transform: 'translateX(-50%)' }}>1</li>
        <li style={{ position: 'absolute', left: '80%', transform: 'translateX(-50%)' }}>80</li>
        <li style={{ position: 'absolute', right: '0%' }}>100</li>
      </ul>
    </div>
  );
};

export default Score;
